import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LocalStorageKeys } from "../core";

const UnprotectedRoute = () => {
  const locationTo = "/";
  
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem(LocalStorageKeys.coachToken);
  });

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === LocalStorageKeys.coachToken) {
        setIsAuthenticated(!!e.newValue);
      }
    };

    const intervalCheck = setInterval(() => {
      const tokenExists = !!localStorage.getItem(LocalStorageKeys.coachToken);
      if (isAuthenticated !== tokenExists) {
        setIsAuthenticated(tokenExists);
      }
    }, 1000); 
    
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(intervalCheck);
    };
  }, [isAuthenticated]);

  return !isAuthenticated ? <Outlet /> : <Navigate to={locationTo} replace />;
};

export default UnprotectedRoute;